<template>
  <b-modal :id="id" size="lg"
           ok-title="Закрыть" :ok-only="true" ok-variant="secondary">

    <template slot="modal-title">
      Комплект #{{ set.id }}

      <set-novelty :is_novelty="set.is_novelty"></set-novelty>
      <set-bestseller :is_bestseller="set.is_bestseller"></set-bestseller>
    </template>

    <div class="row">
      <div class="col">
        <h4>Каталог</h4>
        <table class="table table-sm table-hover table-borderless table-striped">
          <tbody>
          <tr>
            <td style="width: 110px">№</td>
            <td>{{ set.inner_id }}</td>
          </tr>
          <tr>
            <td>Код</td>
            <td>{{ set.code }}</td>
          </tr>
          <tr>
            <td>URL</td>
            <td>{{ set.slug }}</td>
          </tr>
          <tr>
            <td>Направление</td>
            <td v-html="set.root_section"></td>
          </tr>
          <tr>
            <td>Раздел</td>
            <td v-html="set.section"></td>
          </tr>
          </tbody>
        </table>

        <h4>Характеристики</h4>
        <table class="table table-sm table-hover table-borderless table-striped">
          <tbody>
          <tr>
            <td style="width: 110px">Уровень образования</td>
            <td>{{ set.education_levels.map(level => ['', 'НПО', 'СПО', 'ВПО', 'ДБО'][level]).join(', ') }}</td>
          </tr>
          <tr>
            <td>Исполнение</td>
            <td>{{ ['', 'Стендовое', 'Настольное', 'Портативное'][set.implementation] }}</td>
          </tr>
          <tr>
            <td>Управление</td>
            <td>{{ ['', 'Ручное', 'Компьютеризированное'][set.control] }}</td>
          </tr>
          <tr>
            <td>Места</td>
            <td>{{ set.workplaces }}</td>
          </tr>
          <tr>
            <td>Эксперименты</td>
            <td>{{ set.experiments_count }}</td>
          </tr>
          <tr>
            <td>Пусконаладка</td>
            <td>{{ set.commissioning  ? "Да" : "Нет" }}</td>
          </tr>
          <tr>
            <td>Опубликован</td>
            <td>{{ set.is_active ? "Да" : "Нет" }}</td>
          </tr>
          </tbody>
        </table>

        <h4>Состав</h4>
        <table class="table table-sm table-hover table-borderless table-striped">
          <thead>
          <tr>
            <th class="fit">Код</th>
            <th width="450">Наименование</th>
            <th class="fit">Кол-во</th>
            <th>Цена</th>
            <th>Сумма</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="component in set.components" :key="component.id">
            <td>{{ component.code }}</td>
            <td>{{ component.name }}</td>
            <td>{{ component.quantity }}</td>
            <td>{{ component.price | currency }}</td>
            <td>{{ component.price * component.quantity | currency }}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td><b>Итого:</b></td>
            <td><b>{{
                set.price | currency
              }}&nbsp;₽</b></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</template>

<script>

import SetNovelty from '~/Components/Set/SetNovelty'
import SetBestseller from '~/Components/Set/SetBestseller'
export default {
  components: { SetBestseller, SetNovelty },
  props: {
    id: {
      type: String,
      required: true
    },
    set: {
      type: Object,
      required: true
    }
  }
}
</script>
